import { Component, OnDestroy, OnInit } from '@angular/core';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { environment } from '../../../../environments/environment';
import { AppService } from '../../../app.service';
import { NotificationService } from '../../../core/services/notification.service';
import { NotificationType } from '../../../core/services/notification-type';
import { KeyValueObject } from '../../../shared/models/core/KeyValueObject';
import { LeadsReportModel } from '../../../shared/models/reports/leads-report.model';
import { LookupService } from '../../../shared/services/lookup.service';
import { ReportsService } from '../../../shared/services/reports.service';

@Component({
	selector: 'leads-report-form',
	templateUrl: './leads-report-form.component.html',
	styleUrls: [
		'./leads-report-form.component.scss',
		'../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
		'../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
	]
})
export class LeadsReportFormComponent implements OnInit, OnDestroy {
	public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'startsWith' };

	statuses: KeyValueObject[] = [];
	initTypes: KeyValueObject[] = [];

	dataGenerating = false;
	model: LeadsReportModel = new LeadsReportModel();

	private _destroy$ = new Subject<boolean>();

	constructor(
		private lookupService: LookupService,
		private reportsService: ReportsService,
		private notificationService: NotificationService,
		private appService: AppService
	) {
		this.appService.pageTitle = 'Отчёт. Лиды';
	}

	ngOnInit(): void {
		this.lookupService.getDataByUrlExt(`${environment.apiUrl}v1/leads/statuses-lookup`, null)
			.pipe(takeUntil(this._destroy$))
			.subscribe(statuses => {
				this.statuses = statuses || [];
			});

		this.lookupService.getDataForCombobox('init-types', null)
			.pipe(takeUntil(this._destroy$))
			.subscribe(initTypes => {
				this.initTypes = initTypes || [];
			});
	}

	ngOnDestroy(): void {
		this._destroy$.next(true);
		this._destroy$.complete();
	}

	generateReport(): void {
		this.dataGenerating = true;

		this.reportsService.getLeadsReport(this.model)
			.pipe(tap(() => takeUntil(this._destroy$)))
			.subscribe(blob => {
				if (blob.type === 'application/octet-stream') {
					const nowDate = new Date();
					saveAs(blob, `Лиды_${nowDate.toLocaleDateString()}_${nowDate.getHours()}_${nowDate.getMinutes()}_${nowDate.getSeconds()}.xlsx`);
					this.dataGenerating = false;
				} else if (blob.type === 'application/json') {
					blob
						.text()
						.then(result => {
							const response = JSON.parse(result);
							if (!response.isSuccessful) {
								this.notificationService.error({
									title: 'Ошибка',
									message: response.errorDescription as string,
									notificationType: NotificationType.SweetAlert
								});
							}
							this.dataGenerating = false;
						});
				} else {
					this.dataGenerating = false;
				}
			}, () => {
				this.dataGenerating = false;
			});
	}

	get canGenerateReport(): boolean {
		return this.model.startDate != null
			&& this.model.endDate != null
			&& this.model.startDate <= this.model.endDate;
	}
}
